// extracted by mini-css-extract-plugin
export default {"submitButton":"style_submitButton__T+elG","disabled":"style_disabled__aeJef"};